import { MindsetCategoryIconEnum } from '@gap/backend/app-services/mindset/models/MindsetCategoryEnum'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import ChangeCircleOutlined from '@mui/icons-material/ChangeCircleOutlined'
import SportsOutlined from '@mui/icons-material/SportsOutlined'
import SportsKabaddiOutlined from '@mui/icons-material/SportsKabaddiOutlined'
import VolunteerActivismOutlined from '@mui/icons-material/VolunteerActivismOutlined'
import FollowTheSignsOutlined from '@mui/icons-material/FollowTheSignsOutlined'
import NewspaperOutlined from '@mui/icons-material/NewspaperOutlined'
import BusinessOutlined from '@mui/icons-material/BusinessOutlined'
import LeaderboardOutlined from '@mui/icons-material/LeaderboardOutlined'
import MonetizationOnOutlined from '@mui/icons-material/MonetizationOnOutlined'
import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined'
import TimerOutlined from '@mui/icons-material/TimerOutlined'
import Avatar from '@mui/material/Avatar'
import { observer } from 'mobx-react-lite'
import { useCallback, useMemo } from 'react'
import { themeConfig }from '@gap/shared/theme'
import PsychologyOutlined from '@mui/icons-material/PsychologyOutlined'
import GroupsOutlined from '@mui/icons-material/GroupsOutlined'
import TheaterComedyOutlined from '@mui/icons-material/TheaterComedyOutlined'
import SignpostOutlined from '@mui/icons-material/SignpostOutlined'

interface MindsetCategoryIconProps {
   category: MindsetCategoryIconEnum
   selected?: boolean
   onClick?: (category: MindsetCategoryIconEnum) => void
}

export default observer(function MindsetCategoryIcon({ category, selected, onClick }: MindsetCategoryIconProps) {
   const avatarProps = useMemo(() => {
      switch (category) {
         case 'business growth':
            return {
               bgcolor: themeConfig.system.success[100],
               icon: TrendingUpOutlined
            }
         case 'change management':
            return {
               bgcolor: themeConfig.accents.pink[100],
               icon: ChangeCircleOutlined
            }
         case 'coaching':
            return {
               bgcolor: themeConfig.accents.lightblue[200],
               icon: SportsOutlined
            }
         case 'conflict':
            return {
               bgcolor: themeConfig.accents.orange[100],
               icon: SportsKabaddiOutlined
            }
         case 'core values':
            return {
               bgcolor: themeConfig.accents.pink[300],
               icon: VolunteerActivismOutlined
            }
         case 'leadership':
            return {
               bgcolor: themeConfig.system.success[300],
               icon: FollowTheSignsOutlined
            }
         case 'marketing':
            return {
               bgcolor: themeConfig.accents.violet[100],
               icon: NewspaperOutlined
            }
         case 'organisational':
            return {
               bgcolor: themeConfig.accents.yellow[300],
               icon: BusinessOutlined
            }
         case 'performance':
            return {
               bgcolor: themeConfig.accents.violet[300],
               icon: LeaderboardOutlined
            }
         case 'sales':
            return {
               bgcolor: themeConfig.accents.teal[300],
               icon: MonetizationOnOutlined
            }
         case 'systemisation':
            return {
               bgcolor: themeConfig.accents.teal[100],
               icon: AccountTreeOutlined
            }
         case 'time management':
            return {
               bgcolor: themeConfig.accents.orange[300],
               icon: TimerOutlined
            }
         case 'mindset':
            return {
               bgcolor: themeConfig.accents.orange[100],
               icon: PsychologyOutlined
            }
         case 'groups':
            return {
               bgcolor: themeConfig.system.info[100],
               icon: GroupsOutlined
            }
         case 'sign':
            return {
               bgcolor: themeConfig.accents.yellow[300],
               icon: SignpostOutlined
            }
         case 'theater':
            return {
               bgcolor: themeConfig.accents.lightblue[300],
               icon: TheaterComedyOutlined
            }
      }
   }, [category])

   const onClickHandler = useCallback(() => {
      if (onClick) {
         onClick(category)
      }
   }, [onClick, category])

   return (
      <Avatar onClick={onClick ? onClickHandler : undefined} sx={{
         bgcolor: avatarProps.bgcolor,
         borderRadius: '4px',
         display: 'inline-flex',
         ...(onClick ? {
            cursor: 'pointer'
         } : {}),
         ...(selected ? {
            border: `1px solid ${themeConfig.accents.orange[800]}`
         } : {}),
         color: 'black'
      }}>
         <avatarProps.icon />
      </Avatar>
   );
})
